export const pt = {
  // Main namespace - used by filter components from old app
  main: {
    titularidade: 'Titularidade',
    titularidad: 'Titularidade',
    'titularidad-privado': 'PRIVADO',
    'titularidad-publico': 'PÚBLICO',
    'titularidad-municipal': 'MUNICIPAL',
    'titularidad-todo': 'TODOS',
    ref_catastral_search: 'Buscar referência cadastral',
    ref_catastral_placeholder: 'Ex. 06001A123456789A',
    field_report: 'Relatório de campo',
    cadastral_actions_for: 'Ações para',
    cadastral_upload_pick_muni: 'Selecione um município para carregar ficheiros.',
    open_in_map: 'Ver no mapa',
    upload_lab_measures: 'Amostra de laboratório',
    upload_field_report: 'Relatório de campo',
    field_report_details: 'Detalhes do relatório de campo',
    field_report_before_upload:
      'Antes de carregar, indique o tipo de elemento e de amianto observados.',
    field_report_uploaded: 'Relatório de campo carregado — edifício marcado Detalhado',
    upload_and_mark_detailed: 'Carregar e marcar Detalhado',
    document_uploaded: 'Documento carregado',
    document_upload_error: 'Erro ao carregar',
    uso_del_edificio: 'Uso do edifício',
    uso_del_edificio_Industrial: 'Industrial',
    uso_del_edificio_Agrícola: 'Agrícola',
    uso_del_edificio_Retail: 'Retalho',
    uso_del_edificio_Oficinas: 'Escritórios',
    'uso_del_edificio_Servicios Públicos': 'Serviços Públicos',
    uso_del_edificio_Residencial: 'Residencial',
    uso_del_edificio_Otros: 'Outros',
    asbestos_susceptibility: 'Triagem de conter amianto',
    susceptibility_title: 'Triagem mínima de conter amianto representada',
    susceptibility_label_baja: 'Baixa',
    susceptibility_label_media: 'Média',
    susceptibility_label_alta: 'Alta',
    susceptibility_label_muy_alta: 'Muito alta',

    // Map loading
    loading_boundary: 'Carregando delimitação...',
    public_view: 'Vista pública',
    municipal_boundary: 'Limite municipal',

    // FloatingWindow translations
    selected_point: 'Ponto Selecionado',
    add_new_feature: 'Adicionar Novo Elemento',
    edit_feature: 'Editar Elemento',
    area_properties: 'Propriedades da Área',
    layer_groups: 'Grupos de Camadas',
    layers: 'Camadas',
    features: 'Elementos',
    open_in_new_tab: 'Abrir em nova aba',
    link: 'Link',
    close: 'Fechar',
    read_only: 'Somente leitura',
    read_only_mode: 'Modo somente leitura',
    complete_previous_step: 'Completar passo anterior',

    // Context menu
    link_to: 'Link para...',
    change_grid_status: 'Alterar estado da grade para...',
    create_inventory_element: 'Criar elemento de inventário...',
    change_asbestos_presence: 'Alterar presença de amianto para...',

    // Feature property translations
    facade_photo: 'Foto da fachada',
    status: 'Estado',
    matrix_position: 'Posição na grelha',
    n_elements_inside: 'Elementos no interior',
    fx_creation: 'Data de criação',
    fx_modification: 'Data de modificação',
    fx_pending: 'Data pendente',
    fx_in_progress: 'Data em progresso',
    fx_review: 'Data de revisão',
    fx_clear: 'Data de conclusão',
    risk_final_value: 'Valor de risco final',
    risk_type_used: 'Tipo de risco utilizado',
    address: 'Endereço',
    owner: 'Proprietário',
    cadastral_ref: 'Referência Cadastral',
    ref_catastral: 'Referência Cadastral',
    inspection_type: 'Tipo de Inspeção',
    inspection_date: 'Data de Inspeção',
    element_type: 'Tipo de Elemento',
    element_type_cubierta: 'Cobertura',
    element_type_fachada: 'Fachada',
    element_type_chimenea: 'Chaminé',
    element_type_bajantes: 'Descidas',
    element_type_deposito: 'Depósito',
    element_type_numero_de_jardineras: 'Número de floreiras',
    element_type_calorifugados: 'Calorifugados',
    element_type_suelo_vinilico: 'Piso vinílico',
    element_type_numero_de_juntas: 'Número de juntas',
    element_type_otros_elementos: 'Outros elementos',
    is_asbestos: 'Presença de Amianto',
    material_type: 'Tipo de Material',
    material: 'Material',
    // Material categories
    adhesives_cements_sealants: 'Adesivos, Cimentos, Selantes',
    asbestos_paper_board_roll: 'Papel de Amianto, Cartão, Rolo',
    automotive_materials_friction: 'Materiais Automotivos, Fricção',
    cement_pipes_boards_sheets_plastics: 'Tubos de Cimento, Placas, Chapas, Plásticos',
    clay_compounds_paints_plasters: 'Argila, Compostos, Tintas, Gessos',
    electrical_mechanical_products: 'Produtos Elétricos e Mecânicos',
    flooring_tiles: 'Pavimentos, Azulejos',
    gaskets_packings_sealing_materials: 'Juntas, Empanques, Materiais de Vedação',
    household_products: 'Produtos Domésticos',
    panels_drywall_wall_coverings: 'Painéis, Drywall, Revestimentos de Parede',
    pipe_covering_block: 'Cobertura de Tubos, Bloco',
    protective_clothing: 'Roupa de Proteção',
    protective_fireproof_coatings: 'Revestimentos Protetores, Ignífugos',
    raw_asbestos: 'Amianto Bruto',
    refractory_products: 'Produtos Refratários',
    rope_wick_cord_tape_cork: 'Corda, Pavio, Cordão, Fita, Cortiça',
    textiles_felts_fabrics: 'Têxteis, Feltros, Tecidos',
    // Material options - Category 1
    adhesives: 'Adesivos',
    adhesive_cement: 'Cimento Adesivo',
    caulking: 'Calafetagem',
    cement: 'Cimento',
    duct_adhesive: 'Adesivo para Condutas',
    finishing_cement: 'Cimento de Acabamento',
    furnace_cement: 'Cimento de Forno',
    insulating_cement: 'Cimento Isolante',
    joint_cement: 'Cimento para Juntas',
    masonry_cement: 'Cimento de Alvenaria',
    putties: 'Massas',
    mortar: 'Argamassa',
    plastic_cement: 'Cimento Plástico',
    sealant: 'Selante',
    // Material options - Category 2
    asbestos_paper: 'Papel de Amianto',
    corrugated_paper: 'Papel Ondulado',
    flexible_board: 'Cartão Flexível',
    millboard: 'Cartão Prensado',
    permanent_board: 'Cartão Permanente',
    roll: 'Rolo',
    vinyl_wallpaper: 'Papel de Parede de Vinil',
    // Material options - Category 3
    brake_linings: 'Forros de Travão',
    brake_pads: 'Pastilhas de Travão',
    brakes: 'Travões',
    clutch_linings: 'Forros de Embraiagem',
    disc_brakes: 'Travões de Disco',
    drum_brakes: 'Travões de Tambor',
    elevator_brake_shoes: 'Calços de Travão de Elevador',
    transmission_plates: 'Placas de Transmissão',
    // Material options - Category 4
    asbestos_board: 'Cartão de Amianto',
    asbestos_sheets: 'Chapas de Amianto',
    cement_pipes: 'Tubos de Cimento',
    plastics: 'Plásticos',
    stone_coating: 'Revestimento de Pedra',
    // Material options - Category 5
    acoustic_plaster: 'Gesso Acústico',
    asphalt: 'Asfalto',
    filler: 'Massa',
    finishing: 'Acabamento',
    joint_compound: 'Composto para Juntas',
    paint: 'Tinta',
    patching: 'Remendo',
    plaster: 'Gesso',
    putty: 'Massa',
    putty_compounds: 'Compostos de Massa',
    // Material options - Category 6
    boilers: 'Caldeiras',
    cables_wires: 'Cabos e Fios',
    electrical_boards: 'Quadros Elétricos',
    furnaces: 'Fornos',
    generators: 'Geradores',
    heating_ducts: 'Condutas de Aquecimento',
    pumps: 'Bombas',
    turbines: 'Turbinas',
    valve_rings: 'Anéis de Válvula',
    valves: 'Válvulas',
    weather_resistant_jackets: 'Revestimentos Resistentes às Intempéries',
    wiring_insulation: 'Isolamento de Cablagem',
    // Material options - Category 7
    ceiling_tiles: 'Telhas de Teto',
    tiles: 'Azulejos',
    flooring: 'Pavimento',
    slabs: 'Lajes',
    vinyl_linoleum_floors: 'Pisos de Vinil e Linóleo',
    wall_tiles: 'Azulejos de Parede',
    // Material options - Category 8
    braided_packing: 'Empanque Entrançado',
    gasket_material: 'Material de Junta',
    gaskets: 'Juntas',
    packing_material: 'Material de Empanque',
    rope_packing: 'Empanque de Corda',
    sheet_packing: 'Empanque de Folha',
    // Material options - Category 9
    agricultural_filler: 'Enchimento Agrícola',
    attic_insulation: 'Isolamento de Sótão',
    cigarette_filters: 'Filtros de Cigarro',
    clay_pots: 'Vasos de Barro',
    fertilizer: 'Fertilizante',
    exhaust_hoods: 'Exaustores',
    iron_stands: 'Suportes de Ferro',
    ironing_board_covers: 'Capas de Tábua de Engomar',
    lab_hoods: 'Hottes de Laboratório',
    potting_mixes: 'Misturas para Vasos',
    stove_mats: 'Tapetes de Fogão',
    // Material options - Category 10
    acoustic_panels: 'Painéis Acústicos',
    drywall: 'Drywall',
    marine_panel: 'Painel Marítimo',
    panels: 'Painéis',
    gypsum_board: 'Placa de Gesso',
    wallboard: 'Placa de Parede',
    // Material options - Category 11
    block_insulation: 'Isolamento de Bloco',
    calcium_silicate: 'Silicato de Cálcio',
    duct_insulation: 'Isolamento de Condutas',
    insulation: 'Isolamento',
    magnesia: 'Magnésia',
    pipe_insulation: 'Isolamento de Tubos',
    preformed_pipe_wrap: 'Envolvimento de Tubo Pré-formado',
    sponge_block: 'Bloco de Esponja',
    sleeveless_jacket: 'Casaco sem Mangas',
    // Material options - Category 12
    aprons: 'Aventais',
    asbestos_helmet: 'Capacete de Amianto',
    dust_masks: 'Máscaras de Poeira',
    glassblowers_mittens: 'Luvas de Vidreiro',
    gloves: 'Luvas',
    lab_gloves: 'Luvas de Laboratório',
    mittens: 'Luvas sem Dedos',
    respirators: 'Respiradores',
    sleeves: 'Mangas',
    textile_garments: 'Vestuário Têxtil',
    // Material options - Category 13
    asbestos_curtains: 'Cortinas de Amianto',
    asbestos_spray: 'Spray de Amianto',
    boiler_coating: 'Revestimento de Caldeira',
    fireproof_blankets: 'Mantas Ignífugas',
    fire_dampers: 'Comportas Corta-fogo',
    fire_doors: 'Portas Corta-fogo',
    fireproof_cement: 'Cimento Ignífugo',
    fireproof_materials: 'Materiais Ignífugos',
    insulating_coating: 'Revestimento Isolante',
    roof_coating: 'Revestimento de Telhado',
    textured_coatings: 'Revestimentos Texturizados',
    coating: 'Revestimento',
    // Material options - Category 14
    asbestos_fiber: 'Fibra de Amianto',
    fake_snow: 'Neve Falsa',
    calsilite_silicate: 'Silicato de Calsilita',
    talc_powder: 'Pó de Talco',
    transite: 'Transite',
    vermiculite: 'Vermiculita',
    // Material options - Category 15
    castables: 'Refratários Moldáveis',
    refractory_brick: 'Tijolo Refratário',
    marinite: 'Marinite',
    refractory_cement: 'Cimento Refratário',
    // Material options - Category 16
    asbestos_cord: 'Cordão de Amianto',
    asbestos_rope: 'Corda de Amianto',
    cork_coating: 'Revestimento de Cortiça',
    foil_rope: 'Corda de Folha',
    tape: 'Fita',
    wicking: 'Pavio',
    // Material options - Category 17
    asbestos_blanket: 'Manta de Amianto',
    asbestos_canvas: 'Lona de Amianto',
    asbestos_fabric: 'Tecido de Amianto',
    asbestos_felt: 'Feltro de Amianto',
    asbestos_lap: 'Colo de Amianto',
    asbestos_wool: 'Lã de Amianto',
    asbestos_thread: 'Fio de Amianto',
    lagging: 'Calorifugação',
    roving: 'Fio de Fibras',
    textiles: 'Têxteis',
    asbestos_type: 'Tipo de Amianto',

    // Status values
    PENDING: 'Pendente',
    IN_PROGRESS: 'Em Progresso',
    IN_REVIEW: 'Em Revisão',
    REVIEWED: 'Revisado',
    COMPLETED: 'Concluído',
    CLEAR: 'Limpo',

    // Asbestos presence values
    MCA: 'MCA (Contém Amianto)',
    MPCA: 'MPCA (Potencial Amianto)',
    NOMCA: 'NOMCA (Sem Amianto)',

    // Inspection types
    PRELIMINAR: 'Teledetecção',
    BASICO: 'Básico',
    DETALLADO: 'Detalhado',
    DETALLADA: 'Detalhada',
    RETIRADA: 'Remoção',
    VERTIDO: 'Despejo',
    VISUAL: 'Visual',
    LABORATORIO: 'Laboratório',

    // Element types
    CUBIERTA: 'Cobertura',
    FACHADA: 'Fachada',
    BAJANTE: 'Caleira',
    DEPOSITO: 'Depósito',
    TUBERIA: 'Tubagem',
    OTRO: 'Outro',

    // Form actions
    save: 'Guardar',
    delete: 'Eliminar',
    discard: 'Descartar',
    confirm_delete: 'Tem certeza de que deseja eliminar este elemento?',
    confirm_discard: 'Tem certeza de que deseja descartar as alterações?',
    save_success: 'Alterações guardadas com sucesso',
    save_error: 'Erro ao guardar alterações',
    delete_success: 'Elemento eliminado com sucesso',
    delete_error: 'Erro ao eliminar elemento',

    // Carbon sink translations
    carbon_sink_area: 'Área de Sumidouro de Carbono',
    biomass: 'Biomassa',
    co2_captured: 'CO₂ Capturado',
    tree_species: 'Espécie de Árvore',
    plantation_date: 'Data de Plantação',

    // Image gallery translations
    ASBESTOS_INVENTORY: 'Inventário de Amianto',
    EDIFICATION_INVENTORY: 'Inventário de Edificação',
    ASBESTOS_SUSCEPTIBILIDAD: 'Triagem de Amianto',
    REMOVAL_PLAN: 'Plano de Remoção',
    DISPOSAL_CERTIFICATE: 'Certificado de Despejo',
    no_images: 'Sem imagens',
    uploading_image: 'Enviando imagem',
    image_uploaded_successfully: 'Imagem enviada com sucesso',
    deleting_image: 'Eliminando imagem',
    image_deleted_successfully: 'Imagem eliminada com sucesso',
    delete_attachment_title: 'Eliminar Anexo',
    delete_attachment_body: 'Tem certeza de que deseja eliminar este anexo?',
    expand_image: 'Expandir imagem',
    download_image: 'Baixar imagem',
    delete_image: 'Eliminar imagem',
    close_image: 'Fechar imagem',
    cannot_display_image: 'Não é possível exibir a imagem',
    show_more: 'Mostrar mais',
    more: 'mais',
    less: 'menos',
    simple: 'Simples',
    form: 'Formulário',
    risk_form_value: 'Valor do Formulário de Risco',
    risk_simplify_type: 'Tipo de Risco Simplificado',
    // Risk form phases
    questionsPhase1: 'Fase 1 - Exposição',
    questionsPhase2: 'Fase 2 - Estado',
    questionsPhase3: 'Fase 3 - Friabilidade',
    // Risk form questions and responses
    'inspections.equipmentLocation': 'Onde está localizado o material?',
    'inspections.outdoorOrEncapsulated': 'No exterior ou encapsulado',
    'inspections.occasionallyAccessible': 'Local acessível ocasionalmente',
    'inspections.largeAndWellVentilated': 'Local grande e bem ventilado (>1000m³)',
    'inspections.between2501000': 'Local entre 250-1000m³',
    'inspections.lessThan250': 'Local pequeno (<250m³)',
    'inspections.extentQuantity': 'Qual é a extensão/quantidade do material?',
    'inspections.smallQuantities': 'Quantidades pequenas (<1m²)',
    'inspections.lessThan10': 'Menos de 10m²',
    'inspections.between1150': 'Entre 11-50m²',
    'inspections.moreThan51': 'Mais de 51m²',
    'inspections.accessibility': 'Qual é a acessibilidade ao material?',
    'inspections.inaccessible': 'Inacessível',
    'inspections.difficultyAccessible': 'Difícil acesso',
    'inspections.easyAccessible': 'Fácil acesso',
    'inspections.highAccessible': 'Altamente acessível',
    'inspections.potentiallyExposed': 'Quantas pessoas estão potencialmente expostas?',
    'inspections.none': 'Nenhuma',
    'inspections.between13': 'Entre 1-3 pessoas',
    'inspections.between410': 'Entre 4-10 pessoas',
    'inspections.moreThan10': 'Mais de 10 pessoas',
    'inspections.technicalAccessibility': 'Frequência de acesso técnico?',
    'inspections.never': 'Nunca',
    'inspections.occasionally': 'Ocasionalmente',
    'inspections.frequent': 'Frequente',
    'inspections.materialStatus': 'Qual é o estado do material?',
    'inspections.noDamage': 'Sem danos',
    'inspections.littleDamage': 'Danos leves',
    'inspections.mediumDamage': 'Danos médios',
    'inspections.greatDamage': 'Danos graves',
    'inspections.asbestosVariety': 'Que variedade de amianto contém?',
    'inspections.onlyChrysotile': 'Apenas crisotilo',
    'inspections.amphibolesPresence': 'Presença de anfibólios',
    'inspections.friability': 'Qual é a friabilidade do material?',
    'inspections.noFriability': 'Não friável',
    'inspections.lowFriability': 'Friabilidade baixa',
    'inspections.mediumFriability': 'Friabilidade média',
    'inspections.highFriability': 'Friabilidade alta',

    // Layer types
    layer_type: 'Tipo de Camada',
    AMIANTO_CENSO: 'Teledetecção de Amianto',
    SUSCEPTIBILIDAD: 'Triagem',
    GRID: 'Grelha',
    CARBON_SINK: 'Sumidouro de Carbono',

    // Susceptibility layer fields
    ine_code: 'Código INE',
    codigo_ine: 'Código INE',
    n_ref_catastral: 'Número de Referência Cadastral',
    numero_referencia_catastral: 'Número de Referência Cadastral',
    fecha_construccion: 'Data de Construção',
    susceptibilidad: 'Triagem de Conter Amianto',
    susceptibility: 'Triagem de Conter Amianto',
    uso_actual: 'Uso Atual',
    propietario: 'Proprietário',
    google_maps_link: 'Link do Google Maps',
    link_maps: 'Link do Google Maps',
    catastro_link: 'Link do Cadastro',
    link_catastro: 'Link do Cadastro',
    antiguedad: 'Idade do Edifício',
    antiguedad_edificio: 'Idade do Edifício',
    m2_catastro: 'Metros Quadrados Cadastrais',
    metros_cuadrados_catastrales: 'Metros Quadrados Cadastrais',

    // Susceptibility values
    'Muy Alta': 'Muito Alta',
    Alta: 'Alta',
    Media: 'Média',
    Baja: 'Baixa',
    muy_alta: 'Muito Alta',
    alta: 'Alta',
    media: 'Média',
    baja: 'Baixa',

    // Building use values
    'Servicios Públicos': 'Serviços Públicos',
    Industrial: 'Industrial',
    Agrícola: 'Agrícola',
    Retail: 'Retalho',
    Oficinas: 'Escritórios',
    Residencial: 'Residencial',
    Otros: 'Outros',

    // Owner values
    Público: 'Público',
    Privado: 'Privado',
    publico: 'Público',
    privado: 'Privado',

    // Document management
    documents: 'Documentos',
    my_documents: 'Meus documentos',
    your_uploads: 'Seus uploads',
    censo_amianto: 'Teledetecção de amianto',
    susceptibilidad_amianto: 'Triagem de amianto',
    layer_name_AMIANTO_CENSO: 'Teledetecção de amianto',
    layer_name_AMIANTO_SUSCEPTIBILIDAD: 'Triagem de amianto',
    edificacion: 'Edificação',
    lab_measures: 'Amostras de laboratório',
    LAB_MEASURES: 'Amostras de laboratório',
    upload_document: 'Enviar documento',
    upload_not_allowed: 'Você não tem permissão para enviar documentos',
    upload_requires_basic_permission: 'Requer permissão de inspeção básica',
    delete_document: 'Excluir documento',
    download_document: 'Baixar documento',
    no_documents: 'Sem documentos',
    uploading_document: 'Enviando documento',
    deleting_document: 'Excluindo documento',
    document_uploaded_successfully: 'Documento enviado com sucesso',
    document_deleted_successfully: 'Documento excluído com sucesso',
    error_uploading_document: 'Erro ao enviar documento',
    error_deleting_document: 'Erro ao excluir documento',
    error_loading_documents: 'Erro ao carregar documentos',
    delete_document_title: 'Excluir documento',
    delete_document_confirmation: 'Tem certeza de que deseja excluir o documento "{{filename}}"?',
    search_documents: 'Pesquisar documentos',
    search_by_cadastral: 'Pesquisar por ref. cadastral',
    search_by_municipality: 'Pesquisar por município',
    search_by_filename: 'Pesquisar por nome do arquivo',
    filter_by_category: 'Filtrar por categoria',
    filter_by_municipality: 'Filtrar por município',
    filter_by_user: 'Filtrar por usuário',
    all_categories: 'Todas as categorias',
    filename: 'Nome do arquivo',
    category: 'Categoria',
    size: 'Tamanho',
    uploaded_by: 'Enviado por',
    uploaded_at: 'Data de envio',
    actions: 'Ações',
    preview: 'Visualização',
    save_feature_first_to_upload_documents:
      'Salve o elemento primeiro para poder enviar documentos',

    // Process management (RETIRADA/VERTIDO)
    processes: 'Processos',
    removal_processes: 'Processos de Remoção',
    dump_processes: 'Processos de Despejo',
    add_process: 'Adicionar processo',
    no_processes: 'Sem processos',
    no_process_permissions: 'Sem permissão para ver processos',
    error_loading_processes: 'Erro ao carregar processos',

    // Process status options
    PENDIENTE: 'Pendente',
    PROGRAMADA: 'Programado',
    EN_CURSO: 'Em andamento',
    COMPLETADA: 'Concluído',

    // Process priority options
    ALTA: 'Alta',
    MEDIA: 'Média',
    BAJA: 'Baixa',

    // Process fields
    priority: 'Prioridade',
    scheduled_date: 'Data programada',
    completed_date: 'Data concluída',

    // Supplier assignment (renamed from "Partner" per CEO requirement)
    assigned_supplier: 'Fornecedor atribuído',
    select_supplier: 'Selecionar fornecedor',
    suppliers: 'Fornecedores',

    // Removal-specific (RETIRADA)
    removal_plan: 'Plano de remoção aprovado',
    removal_plan_required_hint: 'Documento obrigatório',
    upload_removal_plan: 'Carregar plano de remoção',
    file_too_large: 'O ficheiro é demasiado grande. Tamanho máximo: 50 MB',
    upload_error: 'Erro ao carregar o ficheiro',
    building_permit_cost: 'Custo da licença de obra',
    removal_cost: 'Custo de remoção',
    new_roofing_cost: 'Custo de nova cobertura',
    costs: 'Custos',

    // Dump-specific (VERTIDO)
    disposal_certificate: 'Certificado de despejo',
    disposal_certificate_required_hint: 'Certificado obrigatório de aterro autorizado',
    upload_disposal_certificate: 'Carregar certificado de despejo',
    landfill_name: 'Nome do aterro',
    dump_location: 'Local de despejo',
    landfill_info: 'Informação do aterro',

    // Notes
    notes: 'Notas',

    // Document upload
    replace_document: 'Substituir documento',
    select_file: 'Selecionar arquivo',
    has_document: 'Documento anexado',
    confirm_delete_process: 'Tem certeza de que deseja excluir este processo?',

    // GeoJSON download
    download_geojson: 'Baixar GeoJSON',
    download_geojson_confirm_title: 'Baixar GeoJSON',
    download_geojson_confirm_message: 'Tem certeza de que deseja baixar este arquivo GeoJSON?',
    downloading_geojson: 'Baixando GeoJSON',
    geojson_downloaded_successfully: 'GeoJSON baixado com sucesso',
    geojson_downloading_error: 'Erro ao baixar o GeoJSON',
    // Grid regeneration
    tooltipChangeGrid: 'Regenerar grade',
    regenerating_grid: 'Regenerando grade',
    grid_regenerated_successfully: 'Grade regenerada com sucesso',
    changing_grid_status: 'Alterando status da grade',
    grid_status_changed_successfully: 'Status da grade alterado com sucesso',
    grid_status_change_error: 'Erro ao alterar status da grade',
    no_grid_to_update: 'Não há célula de grade para atualizar',
    from_layer: 'Da camada',
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    name_en: 'Nome (EN)',
    name_es: 'Nome (ES)',
    name_pt: 'Nome (PT)',
    // Fotointerpretation mode
    tooltipTeledeteccion: 'Modo fotointerpretação',
    tooltipFieldMode: 'Modo inspeção em campo (tablet)',
    interpretation_enter: 'Interpretação',
    interpretation_active: 'Interpretação ativa',
    interpretation_exit: 'Sair da interpretação',
    field_mode_enter: 'Modo campo',
    field_mode_active: 'Modo campo ativo',
    field_mode_exit: 'Sair do modo campo',
    exit_edition: 'Sair fotointerpretação',
    // Map controls
    zoom_in: 'Aproximar',
    zoom_out: 'Afastar',
    center_aoi: 'Centrar no município',
    center_user: 'Minha localização',
    reset_rotation: 'Redefinir rotação',
    expand_map: 'Expandir mapa',
    collapse_map: 'Recolher mapa',
    fullscreen: 'Tela cheia',
    exit_fullscreen: 'Sair da tela cheia',
    open_settings: 'Configurações do mapa',
    toggle_snap_guides: 'Ativar/desativar guias de ajuste',
    print: 'Imprimir mapa',
    locating: 'Localizando...',
    exit_draw_polygon_mode: 'Sair do modo de desenho',
    copying_element: 'Copiando elemento',
    element_copied_successfully: 'Elemento copiado com sucesso',
    element_copying_error: 'Erro ao copiar elemento',
    element_selected: 'Elemento selecionado',
    no_inventory_layer: 'Camada de teledetecção não encontrada',
    creating_new_element: 'Criando novo elemento',
    element_created_successfully: 'Elemento criado com sucesso',
    element_creating_error: 'Erro ao criar elemento',
    updating_element: 'Atualizando elemento',
    element_updated_successfully: 'Elemento atualizado com sucesso',
    element_updating_error: 'Erro ao atualizar elemento',

    // Common
    error: 'Erro',
    otros: 'Outros',
    desconocido: 'Desconhecido',
  },
  translation: {
    common: {
      yes: 'Sim',
      no: 'Não',
      connect: 'Conectar',
      save: 'Guardar',
      cancel: 'Cancelar',
      edit: 'Editar',
      success: 'Sucesso',
      error: 'Erro',
    },
    error: { generic: 'Ocorreu um erro' },
    user: {
      user_one: 'Utilizador',
      user_other: 'Utilizadores',
      notFound: 'Utilizador não encontrado',
      fullName: 'Nome completo',
      email: 'Email',
      phone: 'Telefone',
      username: 'Nome de utilizador',
      createdAt: 'Criado em',
      scope: 'Âmbito',
      primaryContact: 'Contacto principal',
      status: { active: 'Ativo', inactive: 'Inativo' },
      details: {
        roles: 'Papéis',
        invitePermissions: 'Permissões de convite',
        accessPermissions: 'Permissões de acesso',
        accessHint: 'As permissões são apenas de leitura.',
      },
      // User management actions
      actions: 'Ações',
      management: 'Gestão de utilizador',
      deactivate: 'Desativar utilizador',
      activate: 'Ativar utilizador',
      deactivated: 'Utilizador desativado',
      activated: 'Utilizador ativado',
      setPrimary: 'Definir como contacto principal',
      setPrimarySuccess: 'Utilizador definido como contacto principal',
      noRoles: 'Sem papéis',
      noInvitePerms: 'Sem permissões de convite',
      // Edição de perfil
      editProfile: 'Editar perfil',
      profileUpdated: 'Perfil atualizado',
      emailNotEditable: 'O email não pode ser alterado',
      // Alteração de senha
      changePassword: 'Alterar senha',
      currentPassword: 'Senha atual',
      newPassword: 'Nova senha',
      confirmNewPassword: 'Confirmar nova senha',
      passwordChanged: 'Senha alterada com sucesso',
      passwordMinLength: 'A senha deve ter pelo menos 8 caracteres',
      passwordMismatch: 'As senhas não coincidem',
    },
    permissions: {
      action: { view: 'Ver', edit: 'Editar' },
      level: {
        basic: 'básico',
        detailed: 'detalhado',
        preliminary: 'teledetecção',
        dump: 'aterro',
        removal: 'remoção',
      },
    },
    entities: {
      municipality_one: 'Município',
      municipality_other: 'Municípios',
      organization_one: 'Organização',
      organization_other: 'Organizações',
      partner_one: 'Fornecedor',
      partner_other: 'Fornecedores',
      global_one: 'Admin',
    },
    supplier: {
      actions: 'Ações',
      management: 'Gestão de fornecedor',
      deactivate: 'Desativar fornecedor',
      activate: 'Ativar fornecedor',
      deactivated: 'Fornecedor desativado',
      activated: 'Fornecedor ativado',
      status: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
    },
    partnerConnection: {
      connectPartnerToMunicipality: 'Conectar fornecedor ao município',
      connectingPartner: 'Conectando fornecedor',
      selectMunicipality: 'Selecionar município',
      partnerConnectedSuccessfully: 'Fornecedor conectado com sucesso',
      errorConnectingPartner: 'Erro ao conectar fornecedor',
    },
    orgManagement: {
      actions: 'Ações',
      management: 'Gestão de organização',
      edit: 'Editar organização',
      updated: 'Organização atualizada',
    },
    entity: {
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      address: 'Endereço',
      website: 'Website',
      cif: 'CIF',
      ine: 'INE',
      realIne: 'INE real',
      realIneDescription: 'Se definido, indica que o INE é sintético',
      syntheticIne: 'INE sintético.',
      razonSocial: 'Razão Social',
      actions: 'Ações',
      management: 'Gestão',
      edit: 'Editar',
      updated: 'Entidade atualizada',
      warning: {
        oneTime:
          '* Só pode ser alterado uma vez. Para modificá-lo depois, contacte o administrador.',
      },
      accessDenied: 'Não tem acesso a esta entidade',
      loadError: 'Erro ao carregar a entidade',
    },
    logs: {
      title: 'Logs do sistema',
      noFiles: 'Nenhum arquivo de log encontrado',
      lines: 'Linhas',
      empty: '(arquivo vazio)',
      loadError: 'Erro ao carregar o arquivo',
      selectFile: 'Seleciona um arquivo de log',
    },
    muniStats: {
      title: 'Estatísticas',
      gridCompletion: 'Inspeção de grelha',
      completedCells: 'células concluídas',
      censoInventory: 'Inventário teledetecção',
      buildings: 'edifícios',
      m2Asbestos: 'm² amianto',
      asbestosPresence: 'Presença de amianto',
      processes: 'Processos',
      noData: 'Sem dados',
      processStatus: {
        PENDIENTE: 'Pendente',
        PROGRAMADA: 'Programada',
        EN_CURSO: 'Em andamento',
        COMPLETADA: 'Concluída',
      },
    },
    login: {
      welcome: 'Bem-vindo',
      subtitle: 'Faça login para continuar',
      email: 'Email',
      emailPlaceholder: 'voce@email.com',
      password: 'Senha',
      passwordPlaceholder: '••••••••',
      button: 'Entrar',
      loading: 'Entrando...',
      backToMap: '← Voltar ao mapa público',
      footer: 'Plataforma de gestão de amianto',
      forgotPassword: 'Esqueceu a senha?',
      invalidCredentials: 'Credenciais inválidas',
      noRoles: 'Não tem papéis atribuídos',
      deactivated: 'O seu município foi desativado. Contacte o administrador.',
      error: 'Erro ao iniciar sessão',
    },
    register: {
      userInfo: 'Informações do Utilizador',
      registerEntity: 'Registrar {{entity}}',
      loading: 'Criando conta...',
      submit: 'Registrar',
    },
    header: {
      profile: 'Perfil',
      logout: 'Sair',
      language: 'Idioma',
      open_invites: 'Convites abertos',
      my_documents: 'Meus documentos',
      logs: 'Logs do sistema',
      user_manual: 'Manual do utilizador',
    },
    footer: {
      privacy: 'Política de privacidade e cookies',
      legal: 'Legal',
      euAlt: 'Governo da Espanha',
    },
    breadcrumbs: {
      dashboard: 'Painel',
      profile: 'Perfil',
      my_documents: 'Meus Documentos',
    },
    report: {
      title: 'Enviar feedback',
      tooltip: 'Partilhe ideias, sugestões ou problemas. Pode incluir uma captura do ecrã atual.',
      comment: 'Comentário',
      comment_placeholder: 'Descreva a sua ideia, sugestão ou problema...',
      send: 'Enviar',
      discard: 'Descartar',
      success: 'Feedback enviado',
      error: 'Não foi possível enviar o feedback',
    },
    dashboard: {
      organizations: 'Organizações',
      municipalities: 'Municípios',
      partners: 'Fornecedores',
      myEntity: 'Minha entidade',
      my: 'Minha',
    },
    entityForm: {
      userEmail: 'E-mail do utilizador',
      primaryUserEmail: 'E-mail do utilizador principal',
      name: 'Nome',
      namePlaceholder: 'Nome da entidade',
      email: 'Email',
      emailPlaceholder: 'Email da entidade',
      phoneNumber: 'Telefone',
      phoneNumberPlaceholder: 'Telefone da entidade',
      address: 'Endereço',
      addressPlaceholder: 'Endereço da entidade',
      website: 'Site',
      websitePlaceholder: 'URL do site',
      cif: 'CIF',
      cifPlaceholder: 'CIF (9 caracteres)',
      razonSocial: 'Razão Social',
      razonSocialPlaceholder: 'Razão social',
      ineCode: 'Código INE',
      ineCodePlaceholder: 'Código INE (5 caracteres)',
      municipalities: 'Municípios',
      municipalitiesPlaceholder: 'Selecione municípios',
      contractStart: 'Início do contrato',
      contractStartPlaceholder: 'YYYY-MM-DD',
      contractEnd: 'Fim do contrato',
      contractEndPlaceholder: 'YYYY-MM-DD',
      contractDocument: 'Documento do contrato',
      uploadContract: 'Carregar contrato',
      loading: 'Criando entidade...',
      submit: 'Criar entidade',
      passwordMismatch: 'As senhas não coincidem',
      firstName: 'Primeiro nome',
      firstNamePlaceholder: 'Digite seu primeiro nome',
      lastName: 'Sobrenome',
      lastNamePlaceholder: 'Digite seu sobrenome',
      userPhoneNumber: 'Telefone',
      userPhoneNumberPlaceholder: 'Digite seu número de telefone',
      username: 'Nome de utilizador',
      usernamePlaceholder: 'Escolha um nome de utilizador (opcional)',
      password: 'Senha',
      passwordPlaceholder: 'Digite sua senha',
      confirmPassword: 'Confirmar senha',
      confirmPasswordPlaceholder: 'Digite novamente sua senha',
      secondLastName: 'Segundo sobrenome',
      secondLastNamePlaceholder: 'Digite seu segundo sobrenome',
      cifError: 'O CIF deve ter exatamente 9 caracteres',
      ineError: 'O código INE deve ter exatamente 5 caracteres',
    },
    list: {
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      address: 'Endereço',
      website: 'Site',
      ine: 'INE',
      razonSocial: 'Razão Social',
      cif: 'CIF',
      firstName: 'Primeiro nome',
      lastName: 'Sobrenome',
      secondLastName: 'Segundo sobrenome',
      phoneNumber: 'Número de telefone',
      isActive: 'Está ativo',
      isPrimaryContact: 'É contato principal',
      username: 'Nome de usuário',
      createdAt: 'Ativo desde',
      inviterEmail: 'Convidado por',

      id: 'ID',
      inviterFullName: 'Nome completo do convidador',
      scopeType: 'Tipo',
      targetName: 'Objetivo',
      scopeId: 'ID do escopo',
      scopeName: 'Nome do escopo',
      roles: 'Papéis',
      municipalityIds: 'IDs de municípios',
      municipalityNames: 'Nomes de municípios',
      status: 'Status',
      expiresAt: 'Expira em',
    },
    listPage: {
      invalidEntityType: 'Tipo de entidade inválido',
      list: 'Lista',
      cards: 'Cartões',
      add: 'Adicionar',
      create: 'Criar',
      filterByName: 'Filtrar por nome...',
      filterByIne: 'Filtrar por INE...',
      filterByRazonSocial: 'Filtrar por razão social...',
      entityType: {
        orgs: 'Organização',
        munis: 'Município',
        partners: 'Fornecedor',
      },
    },
    usersList: {
      search: 'Pesquisar usuários...',
    },
    entityTabs: {
      organization: 'Organização',
      municipalities: 'Municípios',
      partners: 'Fornecedores',
      contracts: 'Contratos',
      noOrgLoaded: 'Nenhuma organização carregada',
      close: 'Fechar',
      map: 'Mapa',
      documents: 'Documentos',
      connectToMunicipality: 'Conectar ao município',
      users: 'Usuários',
      notifications: 'Notificações',
    },
    contracts: {
      partner: 'Fornecedor',
      municipality: 'Município',
      startDate: 'Data de início',
      endDate: 'Data de fim',
      status: 'Estado',
      actions: 'Ações',
      noContracts: 'Nenhum contrato encontrado',
      noContract: 'Sem contrato',
      active: 'Ativo',
      expired: 'Expirado',
      upcoming: 'Próximo',
      viewDocument: 'Ver documento',
      downloadDocument: 'Baixar documento',
      disconnect: 'Desconectar fornecedor',
      disconnectTitle: 'Desconectar fornecedor',
      disconnectConfirmation: 'Tem certeza que deseja desconectar {{partner}} de {{municipality}}?',
      disconnected: 'Fornecedor desconectado com sucesso',
      disconnectError: 'Erro ao desconectar fornecedor',
    },
    actions: 'Ações',
    organization: 'organização',
    municipality: 'município',
    partner: 'fornecedor',
    plural: {
      organization: 'Organizações',
      municipality: 'Municípios',
      partner: 'Fornecedores',
    },
    noDataAvailable: 'Nenhum dado disponível',
    roles: {
      admin_full: 'Administrador — acceso total',
      admin_prelim: 'Administrador — solo teledetecção',
      org_user_admin: 'Administrador de organización',
      org_user_basic_ins: 'Usuario de organização — inspeção básica',
      org_user_detailed_ins: 'Usuario de organização — inspeção detalhada',
      org_user: 'Usuario de organização',
      municipality_user_admin: 'Administrador de municipio',
      municipality_user: 'Usuario de municipio',
      partner_user_admin: 'Administrador de fornecedor',
      partner_user: 'Usuário de fornecedor',
      partner_user_dump: 'Usuário de fornecedor — gestão de vertedouro',
      partner_user_removal: 'Usuário de fornecedor — remoção',
      partner_user_detailed_ins: 'Usuário de fornecedor — inspeção detalhada',
    },
    invites: {
      success: 'Convite enviado com sucesso',
      failure: 'Ocorreu um erro',
      title: 'Convites',
      decline: {
        decline: 'Recusar',
        success: 'Convite recusado',
        error: 'Não foi possível recusar o convite, tente novamente',
        confirm: {
          title: 'Recusar convite',
          message: 'Tem certeza de que deseja recusar este convite para {{email}}?',
          ok: 'Recusar',
          cancel: 'Cancelar',
        },
      },
    },
    // Traduções do painel de filtros
    no_filterable_layers: 'Nenhuma camada filtrável disponível',
    select_layer_to_filter: 'Selecionar camada para filtrar',
    select_layer: 'Selecionar camada',
    // Traduções do painel de camadas
    layer_panel: 'Painel de camadas',
    layer_control: 'Controle de camadas',
    panel_close: 'Fechar',
    collapse_panel: 'Minimizar painel',
    expand_panel: 'Expandir painel',
    tab_visualization: 'Visualização',
    tab_filters: 'Filtros',
    tab_dashboard: 'Painel de controle',
    no_layers_available: 'Nenhuma camada disponível',
    layers_count: '{{count}} grupos de camadas',
    filters_placeholder: 'Os filtros serão configurados aqui',
    dashboard_placeholder: 'O painel de controle será exibido aqui',
    opacity: 'Opacidade',
    style: 'Estilo',
    visualization_selector: 'Visualização',
    legend: 'Legenda',
    loading_legend: 'Carregando legenda',
    legend_unavailable: 'Legenda indisponível',
    toggle_visibility: 'Alternar visibilidade',
    // Traduções de camadas base do mapa
    base_layer_selector: 'Camadas base',
    pnoa_title: 'PNOA Aéreo',
    pnoa_description: 'Imagens aéreas de Espanha (PNOA)',
    osm_title: 'OpenStreetMap',
    osm_description: 'Mapa de ruas colaborativo',
    catastro_title: 'Cadastro',
    catastro_description: 'Parcelas cadastrais de Espanha',
    zonas_catastro_title: 'Cadastro + Aéreo',
    zonas_catastro_description: 'Zonas cadastrais sobre imagens aéreas',
    cyclosm_title: 'CyclOSM',
    cyclosm_description: 'Mapa topográfico orientado ao ciclismo',
    google_satellite_title: 'Google Satélite',
    google_satellite_description: 'Imagens de satélite do Google',
    // ...outras traduções globais...
    // Página de Relatório Público
    publicReport: {
      title: 'Reportar localização de amianto',
      step1Label: 'Localização',
      step1Description: 'Informação do local',
      step2Label: 'Contato',
      step2Description: 'Dados de contato (opcional)',
      municipality: 'Município',
      selectMunicipality: 'Selecionar município',
      location: 'Localização no mapa (opcional)',
      clickToSelect: 'Clique no mapa para selecionar uma localização',
      address: 'Endereço',
      addressPlaceholder: 'Escreva o endereço ou descrição do local',
      cadastralRef: 'Referência cadastral',
      cadastralRefPlaceholder: 'Ex: 0035603VF6703S0001',
      message: 'Descrição',
      messagePlaceholder: 'Descreva a situação do amianto detetado',
      messageMinLength: 'A descrição deve ter pelo menos 10 caracteres',
      images: 'Fotografias',
      imagesHelp: '{{count}} de {{max}} imagens (mínimo 1 requerida)',
      photos: 'Fotografias',
      optional: 'opcional',
      uploadPhoto: 'Carregar foto',
      name: 'Nome',
      namePlaceholder: 'O seu nome (opcional)',
      email: 'Email',
      emailPlaceholder: 'O seu email (opcional)',
      phone: 'Telefone',
      phonePlaceholder: 'O seu telefone (opcional)',
      contactOptional:
        'Os dados de contato são opcionais mas facilitam o acompanhamento do relatório.',
      contactOptionalLabel: 'Dados de contato (opcional)',
      dataProtection:
        'Aceito a política de proteção de dados e o tratamento dos meus dados para gerir este relatório.',
      back: 'Anterior',
      next: 'Seguinte',
      submit: 'Enviar relatório',
      submittingTitle: 'A enviar relatório...',
      successTitle: 'Relatório enviado com sucesso',
      successMessage:
        'Obrigado pelo seu relatório. O município foi notificado e irá analisar a informação fornecida.',
      successSubtitle:
        'Se forneceu um email, receberá atualizações sobre o estado do seu relatório.',
      submitAnother: 'Enviar outro relatório',
      errorTitle: 'Erro',
      errorSubmitting: 'Não foi possível enviar o relatório. Por favor, tente novamente.',
      errorLoadingMunicipalities: 'Não foi possível carregar os municípios',
      invalidEmail: 'Por favor, insira um endereço de email válido',
      invalidPhone: 'Por favor, insira um número de telefone válido',
    },
    // Página do Mapa Público
    publicMap: {
      title: 'Mapa de Amianto',
      login: 'Entrar',
      searchPlaceholder: 'Pesquisar município...',
      typeToSearch: 'Digite pelo menos 2 caracteres para pesquisar',
      noResults: 'Sem resultados',
      selectedMunicipality: 'Selecionado:',
      clickToReport: 'Clique no mapa para marcar uma localização',
      noAoiTitle: 'Sem limites disponíveis',
      noAoiMessage: 'Este município não tem dados geográficos disponíveis.',
      outsideBoundaryTitle: 'Fora do limite',
      outsideBoundaryMessage: 'Por favor, clique dentro do limite do município selecionado.',
      legend: 'Legenda',
      asbestosInventory: 'Inventário de amianto',
      municipalityBoundary: 'Limite municipal',
      reportTitle: 'Selecione uma localização no mapa para continuar',
      coordinates: 'Coordenadas',
    },
    // Painel de Destinatários de Notificações
    notificationRecipients: {
      title: 'Destinatários de notificações',
      description:
        'Gerencie os endereços de email que receberão relatórios públicos de amianto para este município.',
      recipientsCount: 'destinatários',
      email: 'Email',
      emailPlaceholder: 'nome@exemplo.com',
      name: 'Nome',
      namePlaceholder: 'Nome (opcional)',
      status: 'Estado',
      actions: 'Ações',
      add: 'Adicionar',
      active: 'Ativo',
      inactive: 'Inativo',
      noRecipients:
        'Nenhum destinatário configurado. Adicione endereços de email para receber relatórios públicos.',
      added: 'Destinatário adicionado com sucesso',
      deleted: 'Destinatário eliminado',
      errorLoading: 'Não foi possível carregar os destinatários',
      errorAdding: 'Não foi possível adicionar o destinatário',
      errorDeleting: 'Não foi possível eliminar o destinatário',
      errorToggling: 'Não foi possível alterar o estado do destinatário',
    },
  },
}
